// /cms-frontend/cms-frontend/src/utils/helpers.ts

export const formatDate = (dateString: string): string => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return new Date(dateString).toLocaleDateString(undefined, options);
};

export const formatCurrency = (amount: number | null | undefined): string => {
  return new Intl.NumberFormat("en-KE", {
    style: "currency",
    currency: "KES",
    currencyDisplay: "code",
  })
    .format(amount || 0)
    .replace("KES", "KSh");
};

export const calculateTotalFees = (fees: Array<{ amount: number }>): number => {
  return fees.reduce((total, fee) => total + fee.amount, 0);
};

export const generateUniqueId = (): string => {
  return "id-" + Math.random().toString(36).substr(2, 16);
};

export const isValidEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const debounce = (func: Function, delay: number) => {
  let timeoutId: NodeJS.Timeout;
  return (...args: any[]) => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      func(...args);
    }, delay);
  };
};

const EAT_TIMEZONE = "Africa/Nairobi";

/** Format a date as dd/mm/yyyy in EAT (East Africa Time, UTC+3) */
export const formatDateEAT = (date: string | Date): string => {
  return new Date(date).toLocaleDateString("en-KE", {
    timeZone: EAT_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
};

/** Format a time as HH:MM:SS in EAT */
export const formatTimeEAT = (date: string | Date): string => {
  return new Date(date).toLocaleTimeString("en-KE", {
    timeZone: EAT_TIMEZONE,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};

/** Format a full date-time as "dd/mm/yyyy, HH:MM:SS EAT" */
export const formatDateTimeEAT = (date: string | Date): string => {
  return (
    new Date(date).toLocaleString("en-KE", {
      timeZone: EAT_TIMEZONE,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }) + " EAT"
  );
};
